import { useEffect, useState, useCallback } from "react";
import { toast } from "sonner";
import { fetchGrokDrafts, approveGrokDraft, rejectGrokDraft } from "../../lib/api";

export function DraftsPanel({ reloadKey, onChanged }) {
  const [drafts, setDrafts] = useState([]);
  const load = useCallback(async () => {
    try { setDrafts(await fetchGrokDrafts()); } catch { /* empty */ }
  }, []);
  useEffect(() => { load(); }, [load, reloadKey]);

  const act = async (fn, msg) => {
    try { const r = await fn(); toast.success(r?.status === "dry_run" ? `${msg} — logged only (dry-run)` : msg); await load(); onChanged?.(); }
    catch (e) { toast.error(e.response?.data?.detail || "Action failed"); }
  };

  return (
    <div className="border border-zinc-200 bg-white p-5 mb-6" data-testid="grok-drafts-panel">
      <div className="overline mb-1">Grok drafts outside the 24h window</div>
      <div className="font-heading font-black text-lg mb-3">Waiting for your approval <span className="text-zinc-400 font-mono-num text-base">({drafts.length})</span></div>
      {drafts.length === 0 ? (
        <div className="text-sm text-zinc-400 py-6 text-center" data-testid="grok-drafts-empty">No drafts waiting.</div>
      ) : drafts.map((d) => (
        <div key={d.id} data-testid={`grok-draft-${d.id}`} className="border border-zinc-200 p-3 mb-2">
          <div className="text-xs text-zinc-400 mb-1">To {d.lead_name || "lead"} · {d.created_by}</div>
          <div className="text-sm whitespace-pre-wrap mb-3">{d.text}</div>
          <div className="flex gap-2">
            <button data-testid={`grok-draft-approve-${d.id}`} onClick={() => act(() => approveGrokDraft(d.id), "Draft approved")}
              className="px-3 py-1.5 text-xs font-bold uppercase tracking-wider bg-zinc-950 text-white hover:bg-zinc-800">Approve</button>
            <button data-testid={`grok-draft-reject-${d.id}`} onClick={() => act(() => rejectGrokDraft(d.id), "Draft rejected")}
              className="px-3 py-1.5 text-xs font-bold uppercase tracking-wider border border-zinc-300 bg-white hover:bg-zinc-50">Reject</button>
          </div>
        </div>
      ))}
    </div>
  );
}
